// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1mH49","footer":"ChangeClinic_footer__3-h1n"};